import { memo } from "react";
import { isValid } from "date-fns";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { SplitSIcon } from "@icons";
import { HistoryDetailsBaseRow } from "../../cells/historyDetailsBaseRow";
import styles from "./SplitCells.module.scss";

interface SplitDetailDateCellProps {
    row: { original: HistoryDetailsBaseRow };
}

export const SplitDetailDateCell = memo(({ row }: SplitDetailDateCellProps) => {
    const { date, dateOnly } = row.original;
    let dateLabel = "-";
    if (dateOnly) {
        dateLabel = formatDateOnly(dateOnly);
    } else if (isValid(new Date(date))) {
        dateLabel = formatBusinessDate(new Date(date));
    }

    return (
        <ViewTableCell className={styles.splitDetailDate}>
            {dateLabel}
            <div className={styles.splitIconContainer}>
                <SplitSIcon />
            </div>
        </ViewTableCell>
    );
});

SplitDetailDateCell.displayName = "SplitDetailDateCell";
